module.exports = __webpack_public_path__ + "assets/img/activeRules.1754c5a1.png";